if (!customElements.get('product-form')) { 
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const inputVal = this.form.querySelector('[id^="bloomreach_product_json"]');
        const quantityInput = document.querySelector('input[name="quantity"]');
        let quantity = 1;
        let bloomreachData = {};        
        if (inputVal && inputVal.value) {
          try {
            bloomreachData = JSON.parse(inputVal.value);
          } catch (e) {
            console.warn('Error parsing Bloomreach data', e);
          }
        }
        if (quantityInput && quantityInput.value) {
          quantity = parseInt(quantityInput.value, 10) || 1;
        }
        const price = parseFloat(bloomreachData.price) || 0;
        const compareAtPrice = parseFloat(bloomreachData.compare_at_price) || 0;            
        const discount = compareAtPrice > price
          ? Math.round((compareAtPrice - price) * 100) / 100
          : 0; 
        const properties = {
          price: price,
          discount_value: discount,
          currency: Shopify.currency.active || 'AED',
          quantity: quantity
        };
        
        const queryID = sessionStorage.getItem('algolia_queryID');
        const index = sessionStorage.getItem('algolia_index');
        const storedObjectID = sessionStorage.getItem('algolia_objectID');    
        if (queryID) {
          formData.append('properties[_queryID]', queryID);
        }    
        if (queryID && index && storedObjectID && storedObjectID === variantId) {
          Object.entries({
              'properties[_originTrack]': 'Search',
              'properties[_index]': window.algoliaShopify.dynamicIndexName
          }).forEach(([key, value]) => formData.append(key, value));      
          sendConvertedObjectIDsAfterSearch(variantId, 'Product Added To Cart After Search', properties);
        } else {
          Object.entries({
            'properties[_originTrack]': 'PLP',
            'properties[_index]': window.algoliaShopify.dynamicIndexName
          }).forEach(([key, value]) => formData.append(key, value));
          sendConvertedObjectIDs(variantId, 'Product Added To Cart');
          sendAddedToCartObjectIDs(variantId, 'AddedToCartObjectIDs', properties);
        }
      
        if (this.cart && !isMobileView()) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const isMaxQuantityError = response.description?.toLowerCase().includes('maximum quantity');
              const isMainPDP = this.closest('quick-add-modal') === null;

              if (!isMaxQuantityError && isMainPDP) {
                fetch('/?sections=cart-drawer,cart-icon-bubble')
                  .then(res => res.json())
                  .then(sections => {
                    if (this.cart && sections) {
                      this.cart.renderContents({ sections });
                    }
                  });
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;       
            if (this.submitButton.classList.contains('quick-add__submit')) {
              this.submitButton.classList.add('added');
              this.querySelector('.loading__checkmark').classList.remove('hidden');
      
              setTimeout(() => {
                this.submitButton.classList.remove('added');
                this.querySelector('.loading__checkmark').classList.add('hidden');
              }, 2000);
            }   
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    // this.cart.renderContents(response);
                     if (!isMobileView()) {
                      this.cart.renderContents(response);
                    } else {                    
                      showGlobalCartToast?.();
                      this.cart.updateCartCount(response);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // this.cart.renderContents(response);
              if (!isMobileView()) {
                this.cart.renderContents(response);
              } else {                  
                showGlobalCartToast?.();
                this.cart.updateCartCount(response);
              }
            }                    
            getCartData().then(cartData => {
                if (cartData) {                      
                  window.cartBloom_requestStarted(cartData, evt);
                  window.cartBloom_requestComplete(cartData, evt);
                }
            });            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            const isMaxQtyError = this.errorMessage?.textContent?.toLowerCase().includes('maximum quantity');
            if (!this.error || isMaxQtyError) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
               
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          if (errorMessage.toLowerCase().includes('maximum quantity')) {
            this.errorMessageWrapper.setAttribute('hidden', true);
            showVariantError(window.max_qty_reached);
            this.submitButton.removeAttribute('aria-disabled');
            this.handleQuantityError();
          }
        }
        else {          
          this.clearQuantityError();
        }
      }
      handleQuantityError() {      
        const productInfo = this.closest('product-info');
        const sticky_barInfo = document.querySelector('#stick_buybtn_desktop_p');
        const productForm = this;
        if (!productInfo) return;
          productInfo.classList.add('quantity__input--error');    
          if (sticky_barInfo) sticky_barInfo.classList.add('quantity__input--error');  
          if (productForm) {
            productForm.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
      }
      
      clearQuantityError() {
        const productInfo = this.closest('product-info');
        const sticky_barInfo = document.querySelector('#stick_buybtn_desktop_p');        
        if (productInfo) {
          productInfo.classList.remove('quantity__input--error');   
          if (sticky_barInfo) sticky_barInfo.classList.remove('quantity__input--error');
        }        
      }
    }
  );
}
